/**
 * 資料異動通知（R28，照 CRM／PM utils/dataEvents.ts）
 * 新增／編輯／刪除在 API「成功之後」呼叫 notifyDataChanged(topic)：
 * - employees：員工下拉選單重抓（別的對話框馬上看得到新員工）
 * - 發出事件：訂閱者（列表搜尋結果、出勤摘要、報表）各自重新載入
 * 對話框是樂觀更新，onClose 在 API 完成前就會觸發，重抓資料一律掛在這個事件上
 */
import { emitDataChanged, useDataChangedEvent } from '@redpanda/utils';
import { useEmployeeOptionsStore } from '../stores/employeeStore';

export type DataTopic = 'employees' | 'attendance' | 'leaves' | 'payrolls';

export const notifyDataChanged = (topic: DataTopic) => {
  if (topic === 'employees') useEmployeeOptionsStore.getState().fetchAll();
  emitDataChanged(topic);
};

/** 訂閱資料異動（共用實作 @redpanda/utils dataEvents）；handler 不需要 memo */
export const useDataChanged = (topic: DataTopic | DataTopic[], handler: () => void) => useDataChangedEvent(topic, handler);
